import type React from "react";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";

export function ColumnHeaderContainer({
  children,
  onClick,
}: Readonly<ColumnHeaderContainerProps>) {
  const { classes } = useStyles({ hasOnClick: !!onClick });

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (onClick && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <Box
      className={classes.container}
      data-testid="column-header"
      onClick={onClick}
      {...(onClick && {
        role: "button",
        tabIndex: 0,
        onKeyDown: handleKeyDown,
      })}
    >
      {children}
    </Box>
  );
}

const useStyles = makeStyles<{ hasOnClick: boolean }>()(
  (theme, { hasOnClick }) => ({
    container: {
      backgroundColor: theme.palette.blue.light,
      borderRadius: "8px 8px 0 0",
      cursor: hasOnClick ? "pointer" : "default",
    },
  })
);

export interface ColumnHeaderContainerProps {
  children?: React.ReactNode;
  onClick?: () => void;
}
